import isString from 'lodash/isString';
import { isEmail } from 'validator';
import Util from './Util';

class Validation {
	// only allows only numbers and another character(charToAccept) for input fields
	static acceptOnlyNumbersInput = e => {
		const charToAccept = Number(e.target.getAttribute('chartoaccept'));
		if (e.which !== charToAccept && (e.which < 48 || e.which > 57)) {
			e.preventDefault();
		}
	};

	// only allows numbers and a single period
	static validateInputForCurrency = e => {
		const valueFromState = e.target.getAttribute('valuefromstate');
		if (e.which === 46 && valueFromState.includes('.')) {
			e.preventDefault();
		} else {
			this.acceptOnlyNumbersInput(e);
		}
	};

	// only allows numbers, forward slash, and sets max length of 10 characters
	static calendarInputValidation = e => {
		if (e.which !== 47 && (e.which < 48 || e.which > 57)) {
			e.preventDefault();
		} else if (e.target.value.length === 10) {
			e.preventDefault();
		}
	};

	// validates date inputs
	static isValidDate = dateString => {
		if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

		// parse the date
		const parts = dateString.split('/');
		const day = parseInt(parts[1], 10);
		const month = parseInt(parts[0], 10);
		const year = parseInt(parts[2], 10);
		const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

		// Check the ranges of month and year
		if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

		// Adjust for leap years
		if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
			monthLength[1] = 29;
		}

		// Check the range of the day
		return day > 0 && day <= monthLength[month - 1];
	};

	// Ignoring the max length cause max length for user on email is 64 by default, and domain (with .com part) is 63
	static isValidEmail = email => {
		// Regex pattern is same as the one used in Registation Form
		const emailRegex =
			// eslint-disable-next-line prettier/prettier, no-useless-escape
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

		return isString(email) && emailRegex.test(email);
	};

	static isValidAddress = address => {
		const value = address.split('\n');
		for (let i = 0; i < value.length; i++) {
			if (value[i].length > 50 || i > 2) {
				return false;
			}
		}
		return true;
	};

	static isValidPhone = number => {
		const regex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})( ext:\d{1,4})?/;
		return regex.test(number);
	};

	// TODO: remove this as obsolete. isValidPhone covers this case;
	static isValidPhoneWithExt = number => {
		const regex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})( ext:\d{1,4})$/;
		return regex.test(number);
	};

	static isValidZip = zip => {
		const regex = /(^\d{5}$)|(^\d{5}-\d{4}$)/;

		return regex.test(zip);
	};

	static isValidUrl = url => {
		const regex =
			/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;

		return regex.test(url);
	};

	// pass in an object with the error field as the key and the error message as its value
	// this function will parse that object and return the description for the custom showError validation modal
	static buildValidationErrorDescription(errorMessages) {
		let validationErrors = '';

		// eslint-disable-next-line no-restricted-syntax
		for (const error in errorMessages) {
			if (errorMessages[error].length > 0) {
				validationErrors += `<p><b>${Util.formatFieldName(error)}:</b> ${
					errorMessages[error]
				}</p>`;
			}
		}

		return `<p>The following fields are incomplete or in error:</p>${validationErrors}`;
	}
}

export default Validation;
